<!-- 修改 Bl.vue -->
<template>
  <div ref="combinedChart" style="width: 100%; height: 250px;"></div>
</template>

<script>
export default {
  name: "CombinedChart",
  props: {
    chartData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartInstance: null
    }
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
  watch: {
    chartData: {
      handler() {
        this.updateChart();
      },
      deep: true
    }
  },
  methods: {
    initChart() {
      this.chartInstance = this.$echarts.init(this.$refs.combinedChart);
      this.updateChart();
    },
    updateChart() {
      // 处理数据
      const xData = this.chartData.map(item => item.stat_time_hour);
      const calculatedValueData = this.chartData.map(item => item.calculated_value);
      const maxStatCostData = this.chartData.map(item => item.max_stat_cost);
      const roiValue = this.chartData.map(item => item.roi_value);

      const option = {
        title: {
          text: '时间序列组合图'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },grid:{

          bottom: '8%'
        },
        legend: {
          data: ['倍率', '消耗','roi'],
          selected: {'roi':false}
        },
        xAxis: {
          type: 'category',
          data: xData,
          name: '时间'
        },
        yAxis: [
          {
            type: 'value',
            name: '倍率',
            position: 'left'
          },
          {
            type: 'value',
            name: '消耗',
            position: 'right'
          }
        ],
        series: [
          {
            name: '倍率',
            type: 'line',
            yAxisIndex: 0,
            data: calculatedValueData,
            smooth: true,
            markPoint: {
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ]
            }
          },{
            name: 'roi',
            type: 'line',
            yAxisIndex: 0,
            data: roiValue,
            smooth: true,
            markPoint: {
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ]
            }
          },
          {
            name: '消耗',
            type: 'bar',
            yAxisIndex: 1,
            data: maxStatCostData,
            barGap: '0%',
            barCategoryGap: '20%'
          }
        ]
      };

      this.chartInstance.setOption(option);

      // 窗口变化自适应
      window.addEventListener('resize', () => {
        this.chartInstance.resize();
      });
    }
  }
}
</script>
